<template>
  <div
    class="demo__font--16 demo__weight--500 demo__flex demo__flex-middle demo__margin-right-mobile--0"
  >
    <div v-for="item in pages" :key="item.id" :animated="true">
      <a :href="item.url" class="demo__flex demo__flex-middle">
        <a-button
          class="demo__button demo__button--bgSecondary"
          v-if="isMobile"
        >
          <i class="fa-light fa-chevron-left dash-text__white"></i>
        </a-button>
        <div v-else class="demo__flex demo__flex-middle">
          <i class="fa-light fa-chevron-left dash-text__white"></i>
          <span class="demo__margin-left--8 demo__color--white">{{
            item.title
          }}</span>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    windowWidth: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      currentMenu: null,
    };
  },
  computed: {
    ...mapGetters(["module", "modules", "isMobile"]),
    currentModule() {
      return this.$_.findWhere(this.modules, { id: this.module });
    },
    backPath() {
      const isNestedRoute =
        this.currentModule.viewerBackPath.indexOf(":") !== -1;
      let link = this.currentModule.viewerBackPath.split("/");
      if (isNestedRoute) {
        this.currentModule.viewerBackPath.split("/").map((path, index) => {
          link[index] = this.$route.params[path.replace(":", "")]
            ? this.$route.params[path.replace(":", "")]
            : path;
        });
      }
      return link.join("/");
    },
    titles() {
      return {
        edu: this.$t("Cases"),
        AI: this.$t("Studies"),
        community: this.$t("Cases v2"),
      };
    },
    pages() {
      const share = this.$route.query.share
        ? "?share=" + this.$route.query.share
        : "";
      return [
        {
          id: 2,
          title: this.titles[this.module],
          url: this.backPath + share,
        },
      ];
    },
  },
  watch: {
    "$route.path": {
      handler: function (id) {
        if (id.indexOf("options") != -1) {
          this.currentMenu = null;
        }
        this.$debug("Роутер: Активная страница: " + id, "warning");
      },
      deep: true,
    },
  },
  created() {
    this.$accessModule("menu_component", this);
  },
};
</script>
